import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useContext } from "react";
import { ApplicationState } from "../../../context/ApplicationStateContext";
import { useOktaAuth } from "@okta/okta-react";
import buildParams from "../../helpers/paramsBuilder";
import SearchPatientsResponse from "../../../models/API/responseModels/searchPatientsDataResponse.model";
import moment from "moment";
import useStateAndCity from "../useStateAndCity";
import toastMessages from "../../helpers/toastMessage";
import axiosInstance from "../../../api";

function transformResponse(res: string, states: any[]) {
 const response: SearchPatientsResponse = JSON.parse(res);
 if (response?.data?.length > 0)
  return {
   ...response,
   data: response?.data?.map((data) => ({
    ...data,
    id: data?.id ?? "",
    firstName: !!data.firstName ? data.firstName : "---",
    name:
     `${!!data.firstName ? data.firstName : ""} ${
      !!data.lastName ? data.lastName : ""
     }` !== " "
      ? `${!!data.firstName ? data.firstName : ""} ${
         !!data.lastName ? data.lastName : ""
        }`
      : "---",
    patient:
     `${!!data.firstName ? data.firstName : ""} ${
      !!data.lastName ? data.lastName : ""
     }` !== " "
      ? `${!!data.firstName ? data.firstName : ""} ${
         !!data.lastName ? data.lastName : ""
        }`
      : "---",
    middleInitial: !!data.middleInitial ? data.middleInitial : "---",
    lastName: !!data.lastName ? data.lastName : "---",
    birthDate: !!data.birthDate
     ? moment(data.birthDate).format("MM-DD-YYYY")
     : "---",
    gender: !!data.gender ? data.gender : "---",
    address: !!data.address ? data.address : "---",
    city: !!data.city ? data.city : "---",
    state: !!data.state
     ? states?.find?.((state) => state.state_code === data.state)?.name
       ? states?.find?.((state) => state.state_code === data.state)?.name
       : data.state
     : "---",
    zipcode: !!data.zipcode ? data.zipcode : "---",
    ssn: !!data.ssn ? data.ssn : "---",
    mrn: !!data.mrn ? data.mrn : "---",
    email: !!data.email ? data.email : "---",
    phone: !!data.phone ? data.phone : "---",
    stateCode: !!data.state ? data.state : "---",
   })),
  };

 return {
  ...response,
 };
}

function usePatientsList(
 query: string,
 ct?: string,
 sort?: string,
 patientDob?: string
): UseQueryResult<SearchPatientsResponse> {
 const {
  state: { selectedOrganization: organizationId },
 } = useContext(ApplicationState);
 const authState = useOktaAuth()?.authState;
 const { data, isLoading } = useStateAndCity();
 const token = authState?.accessToken?.accessToken ?? "";

 return useQuery({
  queryKey: ["patientsList", { organizationId, query, ct, sort, patientDob }],
  queryFn: ({ queryKey }) => {
   const [_key, { organizationId, query, ct, sort, patientDob }]: any = queryKey;

   return axiosInstance
    .get(
     `/v1/patients/new-flow${buildParams({
      organizationId,
      query,
      ct,
      sort,
      patientDob,
     })}`,
     {
      headers: {
       Authorization: `Bearer ${token}`,
      },
      transformResponse: (res) => transformResponse(res, data),
     }
    )
    .then((res) => {
     return res.data;
    })
    .catch((error) => {
     const msg =
      error?.response?.data?.message ??
      error.message ??
      "Failed to fetch patients";
     toastMessages.error(msg);
    });
  },
  retry: false,
  refetchOnWindowFocus: false,
  enabled: !!token /* && !!organizationId */ && !isLoading,
 });
}

export default usePatientsList;
